/** The version key within the manifest */
export const currentVersionKey = 'v1';
export const ManifestUrlSuffixRelativeToBaseCdnPath = '/odsp-driver/versionless/deploymentManifestOdspDriver.json';
//# sourceMappingURL=OdspDriverManifestType.js.map